<section class="cf-card">
  <h2 class="cf-card__title">{{ section.label }}</h2>

  <div class="cf-card__body">

    <div class="cf-rebates" [formGroup]="form">
      <div [formArrayName]="FIELD.AGENCY_REBATES">
        <div
          class="cf-rebate-row"
          *ngFor="let row of rowGroups; let i = index; trackBy: trackByIndex"
          [formGroupName]="i"
          [class.cf-rebate-row--error]="isDuplicate(row)"
        >
          <div class="cf-field">
            <app-fh-select
              [formControlName]="FIELD.REBATE_CURRENCY"
              [label]="labelFor(FIELD.REBATE_CURRENCY)"
              [options]="currencyOptions"
            ></app-fh-select>
          </div>

          <div class="cf-field">
            <one-input
              type="number"
              [formControlName]="FIELD.REBATE_THRESHOLD"
              [label]="labelFor(FIELD.REBATE_THRESHOLD)"
              (blur)="onThresholdBlur()"
            ></one-input>
            <span class="cf-field__error" *ngIf="isDuplicate(row)">
              {{ REBATE.DUPLICATE_MESSAGE }}
            </span>
            <span
              class="cf-field__error"
              *ngIf="!isDuplicate(row) && showRowError(row, FIELD.REBATE_THRESHOLD)"
            >*Required</span>
          </div>

          <div class="cf-field">
            <one-input
              type="number"
              [formControlName]="FIELD.REBATE_PERCENTAGE"
              [label]="labelFor(FIELD.REBATE_PERCENTAGE)"
            ></one-input>
            <span class="cf-field__error" *ngIf="showRowError(row, FIELD.REBATE_PERCENTAGE)">*Required</span>
          </div>

          <button
            type="button"
            class="cf-rebate-row__remove"
            [attr.aria-label]="LABELS.REMOVE"
            (click)="removeRow(i)"
          >
            <svg width="16" height="16" viewBox="0 0 14 14" fill="none" aria-hidden="true">
              <path d="M10.5 3.5l-7 7M3.5 3.5l7 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
        </div>
      </div>

      <button type="button" class="cf-rebates__add" (click)="addRow()">
        <span class="one-icon-add"></span>
        {{ LABELS.ADD_REBATE }}
      </button>
    </div>

  </div>
</section>
